import posthog from 'posthog-js';
import type { PostHogConfig, Properties } from 'posthog-js';
import { normalizeException } from './shared';

export type ClientExceptionContext = {
  source: string;
  digest?: string;
  path?: string;
  properties?: Properties;
};

function getCurrentPathname(path?: string) {
  if (path) return path;
  if (typeof window === 'undefined') return undefined;
  return window.location.pathname;
}

export function getPostHogBrowserInitConfig(): Partial<PostHogConfig> {
  return {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    capture_dead_clicks: true,
    capture_exceptions: {
      capture_console_errors: false,
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
    },
    capture_pageleave: true,
    capture_pageview: true,
    defaults: '2025-05-24',
    loaded(loadedPostHog) {
      loadedPostHog.register({
        runtime: 'browser',
      });
    },
    rageclick: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },
  };
}

export function captureClientException(error: unknown, context: ClientExceptionContext) {
  const normalizedError = normalizeException(error);
  const path = getCurrentPathname(context.path);
  const properties = {
    ...context.properties,
    ...(context.digest != null && { digest: context.digest }),
    path,
    runtime: 'browser',
    source: context.source,
  } as Properties;

  posthog.captureException(normalizedError, properties);
}
